module.exports = __webpack_public_path__ + "img/main.dc79e630.jpg";